import { createReducer, PayloadAction } from '@reduxjs/toolkit';
import * as ActionTypes from '../actions/types';
import GENERAL_FUNCTIONS from '../utils/functions/functions';
import { fetchFormTypesByPolicyAndCategoryCodeSuccessAction } from '../actions/formType';

type State = {
    loading: boolean;
    formType: {
        byId: { [id: string]: any } | any;
        allIds: Array<string | any>;
    };
};
const INITIAL_STATE: State = {
    loading: false,
    formType: {
        byId: {},
        allIds: [],
    },
};

const fetchFormTypesByPolicyAndCategoryCode = (state: State) => {
    return {
        ...state,
        loading: true,
    };
};

const fetchFormTypesByPolicyAndCategoryCodeSuccess = (
    state: State,
    action: PayloadAction<fetchFormTypesByPolicyAndCategoryCodeSuccessAction>,
): State => {
    const { byId, allIds } = GENERAL_FUNCTIONS.normalizeById(
        'id',
        action.payload.body.data,
    );
    return {
        ...state,
        loading: false,
        formType: {
            ...state.formType,
            byId: byId,
            allIds: allIds,
        },
    };
};

const fetchFormTypesByPolicyAndCategoryCodeFailed = (state: State): State => {
    return {
        ...state,
        loading: false,
    };
};

const fetchFormTypes = (state: State): State => {
    return {
        ...state,
    };
};

const fetchFormTypesSuccess = (state: State): State => {
    return {
        ...state,
    };
};

const fetchFormTypesFailed = (state: State): State => {
    return {
        ...state,
    };
};

const clearFormTypesState = (): State => {
    return INITIAL_STATE;
};

const formType = createReducer(INITIAL_STATE, {
    [ActionTypes.FETCH_FORM_TYPES]: fetchFormTypes,
    [ActionTypes.FETCH_FORM_TYPES_SUCCESS]: fetchFormTypesSuccess,
    [ActionTypes.FETCH_FORM_TYPES_FAILED]: fetchFormTypesFailed,
    [ActionTypes.FETCH_FORM_TYPES_BY_POLICY_AND_CATEGORY_CODE]:
        fetchFormTypesByPolicyAndCategoryCode,
    [ActionTypes.FETCH_FORM_TYPES_BY_POLICY_AND_CATEGORY_CODE_SUCCESS]:
        fetchFormTypesByPolicyAndCategoryCodeSuccess,
    [ActionTypes.FETCH_FORM_TYPES_BY_POLICY_AND_CATEGORY_CODE_FAILED]:
        fetchFormTypesByPolicyAndCategoryCodeFailed,
    [ActionTypes.CLEAR_FORM_TYPES_STATE]: clearFormTypesState,
    [ActionTypes.REDIRECT_AFTER_CLAIM_SUBMIT]: clearFormTypesState,
});

export default formType;
